const CUSTOMER_LOGIN_PHONE_KEY = 'customerLoginPhone';

const getStorage = (): Storage | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
};

export const getSavedCustomerLoginPhone = (): string => {
  const storage = getStorage();

  if (!storage) {
    return '';
  }

  return storage.getItem(CUSTOMER_LOGIN_PHONE_KEY) ?? '';
};

export const saveCustomerLoginPhone = (phone: string): void => {
  const storage = getStorage();

  if (!storage) {
    return;
  }

  const normalizedPhone = phone.trim();

  if (!normalizedPhone) {
    storage.removeItem(CUSTOMER_LOGIN_PHONE_KEY);
    return;
  }

  storage.setItem(CUSTOMER_LOGIN_PHONE_KEY, normalizedPhone);
};
